import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['body', 'toggle']
  static values = {showMore: String, showLess: String}

  connect() {
    this.expanded = false
    this.syncToggleVisibility()
  }

  // A "Show More" button on a note that already fits reads as a bug, so only
  // offer the toggle once the body is actually clipped by the line clamp.
  syncToggleVisibility() {
    const clipped = this.bodyTarget.scrollHeight > this.bodyTarget.clientHeight
    this.toggleTarget.hidden = !clipped
  }

  toggle(event) {
    event.preventDefault()
    this.expanded = !this.expanded
    this.bodyTarget.classList.toggle('note-body-clamped', !this.expanded)
    this.toggleTarget.textContent = this.expanded ? this.showLessValue : this.showMoreValue
  }
}
